export enum PublicRoutes {
  Home = '',
  Signup = 'signup',
  Signin = 'signin',
}
